import _ from 'lodash'
import dayjs from 'dayjs'

type Data = { [key: string]: any } | any[]

export default function formatAllDatesAsDayjs(data: Data): Data {
    if (typeof data === 'string' && isFormattedDate(data)) {
        // return dayjs(data, 'YYYY-MM-DD')
        return dayjs(data)
    } else if (_.isArray(data)) {
        return data.map(item => {
            return formatAllDatesAsDayjs(item)
        })
    } else if (_.isObject(data)) {
        const newData = { ...data }

        for (const key in newData) {
            //@ts-ignore
            newData[key] = formatAllDatesAsDayjs(newData[key])
        }

        return newData
    } else {
        return data
    }
}

// export default function formatAllDatesAsDayjs(data: Data): Data {
//     if (_.isArray(data)) {
//         return data.map(item => {
//             if (isFormattedDate(item)) {
//                 return dayjs(item, 'YYYY-MM-DD')
//             } else if (_.isArray(data) || _.isObject(data)) {
//                 return formatAllDatesAsDayjs(item)
//             } else {
//                 return item
//             }
//         })
//     } else if (_.isObject(data) && data !== null) {
//         const newData: Data = {}

//         for (const key in data) {
//             // @ts-ignore
//             const item = data[key]

//             if (typeof item === 'string' && isFormattedDate(item)) {
//                 newData[key] = dayjs(item, 'YYYY-MM-DD')
//             } else if (_.isArray(data) || _.isObject(data)) {
//                 newData[key] = formatAllDatesAsDayjs(item)
//             } else {
//                 newData[key] = item
//             }
//         }

//         return newData
//     }

//     return data
// }

// console.log(formatAllDatesAsDayjs({ date1: '2024-01-01', date2: '2024-02-20', sel: ['sdf'] }))

function isFormattedDate(date: string) {
    // поддерживаем как простой формат 'YYYY-MM-DD', так и ISO-дату,
    // которая начинается с 'YYYY-MM-DD'
    return date.match(/^\d{4}-\d{2}-\d{2}/)
}
